import React from 'react';

import {
    SettingOutlined,
    UserOutlined,
    DashboardOutlined,
    UsergroupDeleteOutlined,
    FacebookOutlined,
    ClusterOutlined,
    ShoppingOutlined,
    FileDoneOutlined,
    QuestionCircleOutlined,
    FormOutlined,
    HistoryOutlined,
    ClockCircleOutlined,
    ShopOutlined,
    DollarOutlined,
    CustomerServiceOutlined,
    GiftOutlined,
    ProjectOutlined,
    OneToOneOutlined,
    FileTextOutlined,
    DatabaseOutlined,
    IdcardOutlined,
    FileImageOutlined,
    EuroCircleOutlined,
    AreaChartOutlined,
    ExperimentOutlined,
    SolutionOutlined,
    AuditOutlined,
    MedicineBoxOutlined,
    MonitorOutlined,
    FolderOpenOutlined
} from '@ant-design/icons';

const menu = [
    {
        path: '/',
        name: 'Dashboard',
        icon: <DashboardOutlined className="sidebar-icon" />,
        permission: null
    },
    {
        path: '#',
        name: 'Cài đặt',
        icon: <SettingOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/config',
                name: 'Cài đặt hệ thống',
                permission: 'config',
                action: 'update'
            },
            {
                path: '/service',
                name: 'Danh mục dịch vụ',
                permission: 'services',
                action: 'list'
            },
            {
                path: '/procedures',
                name: 'Danh sách thủ thuật',
                permission: 'procedures',
                action: 'list'
            },
            {
                path: '/customer-care-categories',
                name: 'Danh mục CSKH',
                permission: 'customer_care_categories',
                action: 'list'
            },
            {
                path: '/instruction-templates',
                name: 'Mẫu lời dặn',
                permission: 'instruction_templates',
                action: 'list'
            },
            {
                path: '/prescription-templates',
                name: 'Mẫu đơn thuốc',
                permission: 'prescription_templates',
                action: 'list'
            },
            {
                path: '/list-diseases',
                name: 'Danh sách bệnh',
                permission: 'diseases',
                action: 'list'
            },
            {
                path: '/blood-type',
                name: 'Nhóm máu',
                permission: 'blood_type',
                action: 'list'
            },
            {
                path: '/customer-class',
                name: 'Hạng khách hàng',
                permission: 'customer_class',
                action: 'list'
            },
            {
                path: '/customer-status',
                name: 'Trạng thái khách hàng',
                permission: 'customer_status',
                action: 'list'
            },
            {
                path: '/customer-interactive-status',
                name: 'Trạng thái tương tác',
                permission: 'interaction_statuses',
                action: 'list'
            },
            {
                path: '/customer-interactive-type',
                name: 'Loại tương tác',
                permission: 'interaction_types',
                action: 'list'
            },
            {
                path: '/customer-source',
                name: 'Nguồn khách hàng',
                permission: 'customer_source',
                action: 'list'
            },
            {
                path: '/unit',
                name: 'Đơn vị tính',
                permission: 'unit',
                action: 'list'
            },
            {
                path: '/product-status',
                name: 'Tình trạng sản phẩm',
                permission: 'product_status',
                action: 'list'
            },
            {
                path: '/relationship-types',
                name: 'Quan hệ gia đình',
                permission: 'relationship_types',
                action: 'list'
            },
            {
                path: '/document-categories',
                name: 'Danh mục văn bản',
                permission: 'document_categories',
                action: 'list'
            },
            {
                path: '/telegram',
                name: 'Cài đặt telegram',
                permission: 'telegram',
                action: 'list'
            }
        ],
        //isAdminOnly: true
    },
    {
        path: '#',
        name: 'Quản lý cơ sở',
        icon: <ClusterOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/branches',
                name: 'Cơ sở',
                permission: 'branch',
                action: 'list'
            },
            {
                path: '/documents',
                name: 'Văn bản',
                permission: 'documents',
                action: 'list'
            },
            {
                path: '/users',
                name: 'Nhân viên',
                permission: 'user',
                action: 'list'
            },
            {
                path: '/roles',
                name: 'Vai trò',
                permission: 'roles',
                action: 'list'
            },
            {
                path: '/role-group',
                name: 'Nhóm vai trò',
                permission: 'role_group',
                action: 'list'
            },
            {
                path: '/permissions',
                name: 'Phân quyền',
                permission: 'permissions',
                action: 'list'
            }
        ],
        isAdminOnly: true
    },
    {
        path: '#',
        name: 'Quản lý fanpages',
        icon: <FacebookOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/page-list',
                name: 'Danh sách fanpages',
                permission: 'page_manager',
                action: 'list'
            },
            {
                path: '/messenger',
                name: 'Messenger',
                permission: 'messenger',
                action: 'thread'
            },
            {
                path: '/zalo-oa',
                name: 'Zalo OA',
                permission: 'zalo',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Khách hàng',
        icon: <UsergroupDeleteOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            // {
            //     path: '/customer-data?tabs=lookup',
            //     name: 'Dữ liệu khách hàng',
            //     permission: 'customer_data',
            //     action: 'lookup'
            // },
            {
                path: '/customer-group',
                name: 'Nhóm khách hàng',
                permission: 'customer_group',
                action: 'list'
            },
            {
                path: '/customers',
                name: 'Danh sách khách hàng',
                permission: 'customer',
                action: 'list'
            },
            {
                path: '/lookup-customer?tab=all',
                name: 'Tra cứu khách hàng',
                permission: 'lookup_customer',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Khách hàng tiềm năng',
        icon: <UsergroupDeleteOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/customer-group?t=potential',
                name: 'Nhóm KH tiềm năng',
                permission: 'customer_group',
                action: 'list'
            },
            {
                path: '/customer-potential',
                name: 'Danh sách KH tiềm năng',
                permission: 'customer_potential',
                action: 'list'
            }
        ]
    },
    {
        // path: '/customer-schedule?tab=1',
        path: '/customer-schedule2?tab=1',
        name: 'Lịch hẹn',
        icon: <ClockCircleOutlined className="sidebar-icon" />,
        permission: 'customer_schedule',
        action: 'list'
    },
    {
        path: '/telesale-follow-ups',
        name: 'Theo dõi telesale',
        icon: <CustomerServiceOutlined className="sidebar-icon" />,
        permission: 'telesale_follow_up',
        action: 'list'
    },
    // {
    //     path: '/customer-telesale',
    //     name: 'Telesale',
    //     icon: <CustomerServiceOutlined className="sidebar-icon" />,
    //     permission: 'customer_telesale',
    //     action: 'list'
    // },
    // {
    //     path: '/customer-consultant-direct',
    //     name: 'Tư vấn trực tiếp',
    //     icon: <OneToOneOutlined className="sidebar-icon" />,
    //     permission: 'customer_consultant_direct',
    //     action: 'list'
    // },
    {
        path: '/customer-services',
        name: 'Dịch vụ',
        icon: <DatabaseOutlined className="sidebar-icon" />,
        permission: 'customer_services',
        action: 'list'
    },
    {
        path: '#',
        name: 'Quản lý chỉnh nha',
        icon: <MedicineBoxOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/orthodontic-customer',
                name: 'Khách hàng chỉnh nha',
                permission: 'customer',
                action: 'orthodontic_customer'
            },
            {
                path: '/milestone-invisalign',
                name: 'Quản lý ca invisalign',
                permission: 'milestones',
                action: 'list'
            },
        ]
    },
    {
        path: '#',
        name: 'Bác sĩ',
        icon: <FolderOpenOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/doctor-customers',
                name: 'Danh sách bệnh nhân',
                permission: 'doctor_customers',
                action: 'list'
            },
            {
                path: '/doctor-appointments',
                name: 'Lịch hẹn khám',
                permission: 'doctor_appointments',
                action: 'list'
            },
            {
                path: '/treatment-sessions',
                name: 'Phiếu điều trị',
                permission: 'treatment_sessions',
                action: 'list'
            },
        ]
    },
    {
        path: '#',
        name: 'Thu chi',
        icon: <DollarOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/cash-receipt',
                name: 'Phiếu thu',
                permission: 'cash_receipt',
                action: 'list'
            },
            {
                path: '/payment-voucher',
                name: 'Phiếu chi',
                permission: 'payment_voucher',
                action: 'list'
            },
            {
                path: '/branch-funds',
                name: 'Quỹ cơ sở',
                permission: 'branch_fund',
                action: 'list'
            },
            {
                path: '/cash-book',
                name: 'Sổ quỹ',
                permission: 'cash_book',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Tính hoa hồng',
        icon: <EuroCircleOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/commission',
                name: 'Hoa hồng',
                permission: 'commission',
                action: 'list'
            },
            {
                path: '/commission-revenue',
                name: 'Cấu hình doanh thu',
                permission: 'commission_rule',
                action: 'list'
            },
            {
                path: '/commission-rule',
                name: 'Cấu hình quy tắc',
                permission: 'commission_rule',
                action: 'list'
            }
        ]
    },
    {
        path: '#',
        name: 'Báo cáo thống kê',
        icon: <AreaChartOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/revenue-report',
                name: 'Doanh thu & doanh số',
                permission: 'statistics',
                action: 'revenue'
            },
            {
                path: '/staff-revenue-yearly',
                name: 'Doanh số nhân viên (năm)',
                permission: 'statistics',
                action: 'staff_revenue_yearly'
            },
            {
                path: '/staff-revenue-report',
                name: 'Doanh số nhân viên chi tiết',
                permission: 'statistics',
                action: 'staff_revenue_detail'
            },
            {
                path: '/assistants-support-cases',
                name: 'Ca hỗ trợ của phụ tá',
                permission: 'statistics',
                action: 'assistants_support_cases'
            },
            {
                path: '/customer-visits',
                name: 'Thống kê lượt khách đến',
                permission: 'statistics',
                action: 'customer_visits'
            }
        ]
    },
    {
        path: '/monitoring',
        name: 'Giám sát vận hành',
        icon: <MonitorOutlined className="sidebar-icon" />,
        permission: 'monitorings',
        action: 'view'
    },
    {
        path: '#',
        name: 'Quản lý Labo',
        icon: <ExperimentOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/labo-statistics',
                name: 'Thống kê',
                permission: 'labo_cases',
                action: 'status_statistics, customer_statistics'
            },
            {
                path: '/labo-cases',
                name: 'Ca gửi Labo',
                permission: 'labo_cases',
                action: 'list'
            },
            {
                path: '/labos',
                name: 'Đối tác Labo',
                permission: 'labos',
                action: 'list'
            }
        ]
    },
    // {
    //     path: '/media',
    //     name: 'Media',
    //     icon: <FileImageOutlined className="sidebar-icon" />,
    //     permission: 'media',
    //     action: 'list'
    // },
    // {
    //     path: '/voucher-list',
    //     name: 'Voucher',
    //     icon: <ShoppingOutlined className="sidebar-icon" />,
    //     permission: 'voucher',
    //     action: 'list'
    // },
    {
        path: '#',
        name: 'Kho',
        icon: <ShopOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/warehouse',
                name: 'Danh sách kho',
                permission: 'product_warehouse',
                action: 'list'
            },
            {
                path: '/product-supplier',
                name: 'Nhà cung cấp',
                permission: 'product_supplier',
                action: 'list'
            },
            {
                path: '/product-group',
                name: 'Nhóm sản phẩm',
                permission: 'product_group',
                action: 'list'
            },
            {
                path: '/product-list',
                name: 'Sản phẩm',
                permission: 'product',
                action: 'list'
            },
            {
                path: '/product-statistics',
                name: 'Thống kê tồn kho',
                permission: 'product',
                action: 'statistics'
            },
            {
                path: '/receipt-import',
                name: 'Phiếu nhập',
                permission: 'product_receipt_import',
                action: 'list'
            },
            {
                path: '/receipt-export',
                name: 'Phiếu xuất',
                permission: 'product_receipt_export',
                action: 'list'
            }
        ]
    },
    // {
    //     path: '#',
    //     name: 'Quản lý dự án',
    //     icon: <ProjectOutlined className="sidebar-icon" />,
    //     permission: null,
    //     children: [
    //         {
    //             path: '/project',
    //             name: 'Dự án',
    //             permission: 'project',
    //             action: 'list'
    //         },
    //         {
    //             path: '/project-based-job',
    //             name: 'Công việc',
    //             permission: 'project_based_job',
    //             action: 'list'
    //         }
    //     ]
    // },
    // {
    //     path: '#',
    //     name: 'Phân ca',
    //     icon: <FileTextOutlined className="sidebar-icon" />,
    //     permission: null,
    //     children: [
    //         {
    //             path: '/functional-area',
    //             name: 'Khu vực chức năng',
    //             permission: 'functional_area'
    //         },
    //         {
    //             path: '/functional',
    //             name: 'Chức năng của khu vực',
    //             permission: 'functional'
    //         },
    //         {
    //             path: '/jobs',
    //             name: 'Công việc',
    //             permission: 'jobs'
    //         },
    //         {
    //             path: '/shift-scheduling',
    //             name: 'Ca làm việc',
    //             permission: 'shift_scheduling'
    //         }
    //     ]
    // },
    // {
    //     path: '#',
    //     name: 'Thẻ khách hàng',
    //     icon: <IdcardOutlined className="sidebar-icon" />,
    //     permission: null,
    //     children: [
    //         {
    //             path: '/card-pending-customers?tab=pending',
    //             name: 'Khách hàng chờ làm thẻ',
    //             permission: 'card_pending_customers',
    //             action: 'list'
    //         },
    //         {
    //             path: '/card-release-tracking',
    //             name: 'Theo dõi phát hành thẻ',
    //             permission: 'card_release_tracking',
    //             action: 'list'
    //         },
    //         {
    //             path: '/card-issued-count',
    //             name: 'Số lượng thẻ được phát đi',
    //             permission: 'card_issued_count',
    //             action: 'list'
    //         },
    //         {
    //             path: '/card-type',
    //             name: 'Loại thẻ',
    //             permission: 'card_type',
    //             action: 'list'
    //         }
    //     ]
    // },
    {
        path: '/work-report',
        name: 'Báo cáo công việc',
        icon: <FileDoneOutlined className="sidebar-icon" />,
        permission: 'work_report'
    },
    {
        path: '#',
        name: 'Hoạt động',
        icon: <HistoryOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/audit-logs',
                name: 'Audit logs',
                permission: 'audit_logs',
                action: 'search'
            },
            {
                path: '/view-phonenumber',
                name: 'Lịch sử xem số điện thoại',
                permission: 'view_phonenumber',
                action: 'list'
            }
        ]
    },
    {
        path: '/guide',
        name: 'Hướng dẫn sử dụng',
        icon: <QuestionCircleOutlined className="sidebar-icon" />,
        permission: 'guide'
    },
    {
        path: '/feedback-requests',
        name: 'Yêu cầu chỉnh sửa',
        icon: <SolutionOutlined className="sidebar-icon" />,
        permission: 'feedback_requests'
    },
    // {
    //     path: '#',
    //     name: 'Quay thưởng',
    //     icon: <GiftOutlined className="sidebar-icon" />,
    //     permission: null,
    //     children: [
    //         {
    //             path: '/reward-histories?tab=reward_current',
    //             name: 'Giải thưởng',
    //             permission: 'reward_spin',
    //             action: 'list'
    //         },
    //         {
    //             path: '/reward-config',
    //             name: 'Cấu hình',
    //             permission: 'reward_spin',
    //             action: 'config'
    //         },
    //         {
    //             path: '/reward-customer-has',
    //             name: 'Khách hàng đã quay',
    //             permission: 'reward_spin',
    //             action: 'customer_has_list'
    //         }
    //     ]
    // },
    {
        path: '#',
        name: 'Đối tác',
        icon: <SolutionOutlined className="sidebar-icon" />,
        permission: null,
        children: [
            {
                path: '/partner-customers',
                name: 'Danh sách khách hàng',
                permission: 'partner_customers',
                action: 'list'
            },
            // {
            //     path: '/partner-appointments',
            //     name: 'Lịch hẹn',
            //     permission: 'partner_appointments',
            //     action: 'list'
            // },
            // {
            //     path: '/partner-telesales',
            //     name: 'Telesales',
            //     permission: 'partner_telesales',
            //     action: 'list'
            // }
        ]
    },
    // {
    //     path: '/editor',
    //     name: 'Editor',
    //     icon: <AuditOutlined className="sidebar-icon" />,
    //     permission: null
    // },

    {
        path: '/profile',
        name: 'Thông tin tài khoản',
        icon: <UserOutlined className="sidebar-icon" />,
        permission: null,
    }
];

export default menu;